import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHomeOutline = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 15,
	viewBox: "0 0 16 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M16 7.53125C16 7.36719 15.918 7.17578 15.7539 7.03906L8.53516 0.914062C8.42578 0.804688 8.26172 0.75 8.125 0.75C7.96094 0.75 7.79688 0.804688 7.6875 0.914062L0.46875 7.03906C0.304688 7.17578 0.25 7.36719 0.25 7.53125C0.25 7.99609 0.605469 8.1875 0.90625 8.1875C1.04297 8.1875 1.20703 8.16016 1.31641 8.05078L2 7.47656V13.6562C2 14.2852 2.46484 14.75 3.09375 14.75H5.71875C6.32031 14.75 6.8125 14.2852 6.8125 13.6562V10.375H9.4375V13.6562C9.4375 14.2852 9.90234 14.75 10.5039 14.75H13.1289C13.7578 14.75 14.2227 14.2852 14.2227 13.6562V7.47656L14.9062 8.05078C15.0156 8.16016 15.1797 8.1875 15.3164 8.1875C15.6172 8.1875 16 7.96875 16 7.53125ZM12.9102 13.4375H10.7227V10.1562C10.7227 9.55469 10.2578 9.0625 9.65625 9.0625H6.59375C5.96484 9.0625 5.5 9.55469 5.5 10.1562V13.4375H3.3125V6.4375C3.3125 6.4375 3.28516 6.41016 3.28516 6.38281L8.125 2.28125L12.9102 6.35547V13.4375Z",
		fill: "#42A5F5"
	})]
});
const ForwardRef = forwardRef(SvgHomeOutline);
export { ForwardRef as ReactComponent };
